import log from "js/core/logger";

const bundleGetters = {
    9: () => import(/* webpackChunkName: "canvasV9" */ "./v9"),
    10: () => import(/* webpackChunkName: "canvasV10" */ "./v10")
};

const availableBundleVersions = Object.keys(bundleGetters).map(version => parseInt(version)).sort((a, b) => a - b);

/**
 * Fetches canvas bundle for the given version
 * @param {number} version numeric slide version
 */
export function getCanvasBundle(version) {
    if (!availableBundleVersions.includes(version)) {
        let closestVersion = availableBundleVersions.find(availableVersion => availableVersion >= version);
        if (!closestVersion) {
            throw new Error("Requested version is too high!");
        }

        log.warn(`Cannot find bundle version ${version}, will use closest version ${closestVersion}`);
        return bundleGetters[closestVersion]();
    }

    return bundleGetters[version]();
}
